import { useQuery } from '@tanstack/react-query';

import { fetchData } from '..';

import type { Segment } from './get-segments';
import type { QueryKey } from '@tanstack/react-query';

export type SegmentLite = Pick<Segment, 'IsDeleted' | 'Name' | 'SegmentId'>;

export const GET_SEGMENTS_LITE = 'api/segment/get-segment-list-lite';

export const segmentsLiteQueryKey: QueryKey = ['segments-lite'];

export function useGetSegmentsLiteQuery() {
  return useQuery({
    queryKey: segmentsLiteQueryKey,
    queryFn: () => fetchData<SegmentLite[]>(GET_SEGMENTS_LITE),
  });
}
